import { Box, Tooltip } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";
import {
  DoubleTickIcon,
  GmailLogoIcon,
  DoneIcon,
} from "Components/Shared/Icons";
import { EmployeeStatus } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import type { FC } from "react";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";

const STATUS_TO_ICON: Record<
  EmployeeStatus,
  FC<{ width: string; height: string }> | null
> = {
  [EmployeeStatus.Inactive]: DoNotDisturbIcon,
  [EmployeeStatus.InvitedWaitingForConfirmation]: GmailLogoIcon,
  [EmployeeStatus.Active]: DoubleTickIcon,
  [EmployeeStatus.Created]: DoneIcon,
};

const STATUS_TO_COLOR: Record<EmployeeStatus, string> = {
  [EmployeeStatus.Inactive]: Colors.Border,
  [EmployeeStatus.InvitedWaitingForConfirmation]: Colors.Warning,
  [EmployeeStatus.Active]: "green",
  [EmployeeStatus.Created]: Colors.Warning,
};

type Props = {
  status: EmployeeStatus;
};

export const EmployeeStatusCell = ({ status }: Props) => {
  const { t } = useResource();
  const Icon = STATUS_TO_ICON[status];
  const color = STATUS_TO_COLOR[status];

  return (
    <Tooltip title={t(Resources.Employee.EmployeeStatus[status])}>
      <Box display="flex" color={color}>
        {Icon && <Icon width="1rem" height="1rem" />}
      </Box>
    </Tooltip>
  );
};
